module.exports = __webpack_public_path__ + "public/img/pintar.e3bafd09.png";